import { LAYOUTS, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION, } from './types';
import _ from 'lodash';
import { closeMaxLimitErrorModal, editButtonAction, enhanceLimit, getURL, goBack, navigateToDashboard, navigateToFAQ, navigateToLandingPage, navigation, needHelp, unPledge, verifyOtp } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { CreditApplicationType, getAppHeader } from '../../../configs/config';
import { getContactUsDetails, removeUrlWithoutReload } from '../../../configs/utils';
import { QUERY_PARAMS, TARGET_PAGES } from '../../../configs/constants';
import sharedPropsService from "../../../SharedPropsService";
export const template = (creditStatus, isAllowed, platform, height, creditResponse, tempCreditResponse, creditAmount, sanctionedLimit, totalOutstanding, phoneNumber, lenderName, extraOutstandingBufferBajaj, contactUsDetails, isFromJupiter, extraOutstandingBufferDsp) => {
    return {
        layout: {
            id: ROUTE.UNPLDEGE_FUNDS,
            type: LAYOUTS.LIST,
            widgets: [
                { id: "manageLimit", type: WIDGET.UNPLEDGE_PORTFOLIO }
            ],
        },
        datastore: {
            headerStack: {
                type: StackType.column,
                width: StackWidth.MATCH_PARENT,
                widgetItems: [
                    { id: 'headerStackTitleStack', type: WIDGET.STACK },
                    { id: 'headerStackSpace0', type: WIDGET.SPACE },
                    { id: 'headerStackDivider', type: WIDGET.DIVIDER }
                ]
            },
            manageLimit: {
                height: height,
                bankData: creditResponse,
                tempCreditResponse,
                creditLimit: creditAmount,
                lenderName: lenderName,
                phoneNumber: phoneNumber,
                backAction: {
                    type: ACTION.MENU,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                    payload: { totalOutstanding, extraOutstandingBufferBajaj, extraOutstandingBufferDsp },
                },
                profileAction: {
                    type: ACTION.UNPLEDGE,
                    payload: {},
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                applyAction: {
                    type: ACTION.VERIFY_OTP,
                    payload: {},
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                continuePress: {
                    type: ACTION.MARGIN_CALL,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                addBankAction: {
                    type: ACTION.NAVIGATE_TO_LANDING_PAGE,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                skipBankAction: {
                    type: ACTION.NAVIGATE_DASHBOARD,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                },
                sanctionedAmount: sanctionedLimit,
                totalOutstanding: totalOutstanding,
                extraOutstandingBufferBajaj,
                extraOutstandingBufferDsp,
                needHelp: {
                    type: ACTION.NEED_HELP,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                    payload: {}
                },
                otpErrorModal: false,
                contactUsDetails,
                isFromJupiter,
                editButtonClickedAction: {
                    type: ACTION.EDIT_BUTTON_ACTION,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                    payload: {}
                },
                closeMaxLimitErrorModal: {
                    type: ACTION.CLOSE_MAX_LIMIT_ERROR_MODAL,
                    routeId: ROUTE.UNPLDEGE_FUNDS,
                    payload: {}
                }
            },
            headerStackTitleStack: {
                width: StackWidth.MATCH_PARENT,
                padding: {
                    top: SizeTypeTokens.LG,
                    // bottom: SizeTypeTokens.LG,
                    left: SizeTypeTokens.XL,
                    right: SizeTypeTokens.XL
                },
                widgetItems: [
                    { id: 'headerStackTitle', type: WIDGET.TEXT },
                ]
            },
            headerStackSpace0: {
                size: SizeTypeTokens.LG
            },
            headerStackTitle: {
                label: 'Manage Limit',
                fontFamily: FontFamilyTokens.Poppins,
                fontSize: FontSizeTokens.MD,
                fontWeight: '700',
            },
            headerStackDivider: {
                size: DividerSizeTokens.MD,
                color: ColorTokens.Grey_Milk,
            },
            headSpace: { size: SizeTypeTokens.MD },
            title: {
                label: 'Get holding statement report',
                fontSize: FontSizeTokens.MD,
                lineHeight: 24,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
            },
            titleSpace: { size: SizeTypeTokens.MD },
            subTitle: {
                label: 'View your pledged portfolio details',
                fontSize: FontSizeTokens.SM,
                lineHeight: 24,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
            },
            subTitleSpace: { size: SizeTypeTokens.Size32 },
            inputSpace: { size: SizeTypeTokens.XXL },
            toInputSpace: { size: SizeTypeTokens.XXL },
            continue: {
                label: 'Email holding statement',
                labelColor: creditStatus === 'PENDING_DISBURSAL_APPROVAL'
                    ? ColorTokens.Grey_Charcoal
                    : ColorTokens.White,
                fontFamily: FontFamilyTokens.Poppins,
                type: creditStatus === 'PENDING_DISBURSAL_APPROVAL'
                    ? ButtonTypeTokens.LargeOutline
                    : ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.EMAIL,
                    payload: {
                        value: '',
                        widgetId: 'continue',
                        isResend: false,
                    },
                    routeId: ROUTE.MANAGE_LIMIT,
                },
            },
            spaceAfterContinue: { size: SizeTypeTokens.Size32 },
            enhanceLimitCTA: {
                label: 'Enhance your limit',
                labelColor: ColorTokens.White,
                fontFamily: FontFamilyTokens.Poppins,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.ENHANCE_LIMIT,
                    payload: {
                        applicationType: CreditApplicationType.CREDIT_MODIFICATION_AGAINST_SECURITIES,
                    },
                    routeId: ROUTE.MANAGE_LIMIT,
                },
            },
            spaceAfterEnhanceLimit: { size: SizeTypeTokens.Size32 },
            marginCallCTA: {
                label: 'Margin call',
                labelColor: ColorTokens.White,
                fontFamily: FontFamilyTokens.Poppins,
                type: ButtonTypeTokens.LargeFilled,
                width: ButtonWidthTypeToken.FULL,
                action: {
                    type: ACTION.ENHANCE_LIMIT,
                    payload: {
                        applicationType: CreditApplicationType.CREDIT_MODIFICATION_MARGIN_CALL_AGAINST_SECURITIES,
                    },
                    routeId: ROUTE.MANAGE_LIMIT,
                },
            },
        },
    };
};
export const unpledgeFunds = {
    onLoad: async ({ getHeight, instrumentTrack, network }, { target, netPayable, extraOutstandingBufferBajaj, extraOutstandingBufferDsp }) => {
        const creditStatus = await SharedPropsService.getCreditStatus();
        const user = await SharedPropsService.getUser();
        const contactUsDetails = await getContactUsDetails();
        const creditAmount = user.linkedCredits[0].totalDrawingPower;
        const isFromJupiter = await SharedPropsService.getAppPlatform() === "JUPITER" /* AppPlatform.JUPITER */;
        const phoneNumber = user.user.phoneNumber;
        const lenderName = user?.linkedCredits[0]?.lendingPartnerId;
        const sanctionedLimit = user.linkedCredits[0].approvedCreditAmount;
        const requestOptions = {
            method: 'GET',
            headers: await getAppHeader(),
        };
        const totalOutstanding = netPayable;
        if (target && target === TARGET_PAGES.MANAGE_LIMIT) {
            removeUrlWithoutReload(QUERY_PARAMS.TARGET);
        }
        const creditShallowResponse = await SharedPropsService.getPortfiolioData();
        const creditResponse = _.cloneDeep(creditShallowResponse);
        const tempCreditResponse = await SharedPropsService.getPortfiolioData();
        tempCreditResponse.forEach(asset => {
            Object.defineProperty(asset, 'assetPledgedValue', {
                writable: false,
                configurable: false,
            });
        });
        instrumentTrack('CONFIRM_UNPLEDGE_PAGE_VIEWED');
        const platform = await sharedPropsService.getAppPlatform();
        return Promise.resolve(template(creditStatus, true, platform, getHeight(), creditResponse, tempCreditResponse, creditAmount, sanctionedLimit, totalOutstanding, phoneNumber, lenderName, extraOutstandingBufferBajaj, contactUsDetails, isFromJupiter, extraOutstandingBufferDsp));
    },
    actions: {
        [ACTION.EMAIL]: getURL,
        [ACTION.NAVIGATION]: navigation,
        [ACTION.MENU]: goBack,
        [ACTION.UNPLEDGE]: unPledge,
        [ACTION.ENHANCE_LIMIT]: enhanceLimit,
        [ACTION.MARGIN_CALL]: navigateToFAQ,
        [ACTION.VERIFY_OTP]: verifyOtp,
        [ACTION.NAVIGATE_DASHBOARD]: navigateToDashboard,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.NAVIGATE_TO_LANDING_PAGE]: navigateToLandingPage,
        [ACTION.EDIT_BUTTON_ACTION]: editButtonAction,
        [ACTION.CLOSE_MAX_LIMIT_ERROR_MODAL]: closeMaxLimitErrorModal,
    },
};
